import { ShoppingCartConfigurationBundleDto } from "@/api/models/shoppingCart.model";
import { ProductChangeOfAddress2ndPhaseService } from "@/api/services/productChangeOfAddress2ndPhaseProcess.service";
import { PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_ACTION, PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_STATE } from "./constants";
import { VoipNumberPoolStoreMutations } from "../voipNumberPool";

const clear = ({ commit }: any) => {
	commit(PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_STATE);

	commit(VoipNumberPoolStoreMutations.CLEAR);
};

const getProductChangeOfAddress2ndPhaseById = ({ commit }: any, processId: string) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddress2ndPhaseService.getById(processId)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const patchProductChangeOfAddress2ndPhaseProcess = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddress2ndPhaseService.patch(payload.id, payload.data)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveProductChangeOfAddress2ndPhaseProcess = ({ commit }: any, changeOfAddress2ndPhase: any) => {
	commit("SET_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS", changeOfAddress2ndPhase);
};

const saveProductChangeOfAddress2ndPhaseProcessStatus = ({ commit }: any, status: any) => {
	commit("SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_STATUS", status);
};

const getProductChangeOfAddress2ndPhaseProcessSummary = ({ commit }: any, { shoppingCartId }: { shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddress2ndPhaseService.getSummary({ shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveProductChangeOfAddress2ndPhaseProcessShoppingCartId = ({ commit }: any, shoppingCartId: string) => {
	commit("SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_SHOPPING_CART_ID", shoppingCartId);
};

const saveChangeOfAddress2ndPhaseSelectedProduct = ({ commit }: any, payload: string) => {
	commit("SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_PRODUCT_SELECTED", payload);
};

const getChangeOfAddress2ndPhaseConfiguration = ({ commit }: any, { shoppingCartId }: { shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddress2ndPhaseService.getChangeOfAddress2ndPhaseConfiguration({ shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateChangeOfAddress2ndPhaseConfiguration = (
	{ commit }: any,
	{ shoppingCartId: id, bundles }: { shoppingCartId: string; bundles: ShoppingCartConfigurationBundleDto[] }
) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddress2ndPhaseService.putChangeOfAddress2ndPhaseConfiguration({ id, bundles })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const sendChangeOfAddress2ndPhase = ({ commit }: any, processId: string) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddress2ndPhaseService.send(processId)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveOrderChangeOfAddress2ndPhase = ({ commit }: any, payload: string) => {
	commit("SET_ORDER_CHANGE_OF_ADDRESS_2ND_PHASE", payload);
};

export default {
	[PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_ACTION]: clear,
	getProductChangeOfAddress2ndPhaseById,
	patchProductChangeOfAddress2ndPhaseProcess,
	saveProductChangeOfAddress2ndPhaseProcess,
	saveProductChangeOfAddress2ndPhaseProcessStatus,
	getProductChangeOfAddress2ndPhaseProcessSummary,
	saveProductChangeOfAddress2ndPhaseProcessShoppingCartId,
	saveChangeOfAddress2ndPhaseSelectedProduct,
	getChangeOfAddress2ndPhaseConfiguration,
	updateChangeOfAddress2ndPhaseConfiguration,
	sendChangeOfAddress2ndPhase,
	saveOrderChangeOfAddress2ndPhase
};
